import Joi from 'joi';

import { fileSchema } from '../../../../shared/modules/files/validators/schemas/file.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';

/**
 * Schema for existing vehicle group record validation.
 */
export const updateVehicleGroupSchema = () =>
  Joi.object({
    id: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|vehicle-group-id|cannot-be-null',
        }),
        otherwise: Joi.number().required().messages({
          'any.required': 'validations|vehicle-group-id|required',
          'number.base': 'validations|vehicle-group-id|must-be-number',
        }),
      })
      .prefs({ abortEarly: true }),
    name: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|vehicle-group-name|cannot-be-null',
        }),
        otherwise: Joi.string().required().messages({
          'any.required': 'validations|vehicle-group-name|required',
          'string.base': 'validations|vehicle-group-name|must-be-string',
          'string.empty': 'validations|vehicle-group-name|cannot-be-empty',
        }),
      })
      .prefs({ abortEarly: true }),
    description: Joi.string().allow(null, '').messages({
      'string.base': 'validations|vehicle-group-description|must-be-string',
    }),
    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|vehicle-group-notes|must-be-string',
    }),
    files: Joi.array().items(fileSchema()).allow(null).messages({
      'array.base': 'validations|vehicle-group-files|invalid-value',
    }),
    tags: createTagsSchema().allow(null).messages({
      'array.base': 'validations|vehicle-group-tags|invalid-value',
    }),
  }).unknown();
